import React from 'react';
import PropTypes from 'prop-types';
import InlineSVG from 'svg-inline-react';
import shortId from 'shortid';

import xMark from '../../assets/images/x-mark.svg';

const MAX_ICONS_NUMBER = 3;

const getIconsNumber = numOfIcons => Math.min(MAX_ICONS_NUMBER, parseInt(numOfIcons, 10));

const renderIcons = numOfIcons =>
    Array(getIconsNumber(numOfIcons))
        .fill(1)
        .map(() => <InlineSVG key={shortId.generate()} className='dashboard-x-mark' src={xMark} />);

const MeasureSelectionDropdownItem = ({ label, numOfUsedForms, genre }) => {
    return (
        <div className='dashboard-dropdown-item'>
            <div className='dashboard-dropdown-label'>
                <span className='dashboard-dropdown-label-text-truncated'>{label}</span>
                {genre && <span className='dashboard-dropdown-genre'>{`(${genre})`}</span>}
                {renderIcons(numOfUsedForms)}
            </div>
        </div>
    );
};

MeasureSelectionDropdownItem.propTypes = {
    label: PropTypes.string.isRequired,
    numOfUsedForms: PropTypes.number,
    genre: PropTypes.string,
};

MeasureSelectionDropdownItem.defaultProps = {
    numOfUsedForms: 0,
    genre: '',
};

export default MeasureSelectionDropdownItem;
